<template>
  <div class="menu">
    <ul>
      <li
        :class="{ activeMenu: current == index }"
        v-for="(item, index) in items"
        :key="index"
        @click="this.$emit('init', { param: index })"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MenuGames",
  props: {
    current: String,
    items: Object,
  },
  data: () => ({}),
};
</script>

<style lang="scss">
.activeMenu {
  font-weight: bold;
  border: 2px solid #000 !important;
}
.menu ul {
  display: flex;
  padding: 0;
  li {
    cursor: pointer;
    list-style: none;
    border: 1px solid #000;
    padding: 0.5rem 2.5rem;
    font-size: 0.8rem;
    &:not(:last-child) {
      margin-right: 1rem;
    }
    @media (max-width: 1200px) {
       padding: .5rem;
       &:not(:last-child) {
        margin-right:0rem;
      }
    }
  }
}
</style>